import { sectorConstants, alertConstants } from '../_constants'
const initialState = {
  isLoading: false,
  sectorEntry: null,
  addSectorMessage: null,
  count: 0,
  sectorList: [],
  isGetAllError: false,
  deletedData: {},
  masterList: null,
  updateFilterMessage: '',
  isErrorOnUploadFilter: false,
  updateSectorMessage: null,
  currentPage: 0,
  isPageLoad: true,
  chartDataMessage: null,
  chartData: null,
  chartNode:null,
  industryChartData:null,
  selectedCompany:null
}

export function sector(state = { ...initialState }, action) {
  switch (action.type) {
  case sectorConstants.LINK_COMPANY_REQUEST:
    return { ...state,
      selectedCompanyNode: action.node }
  case sectorConstants.LINK_COMPANY_SUCCESS:
    return { ...state,
      selectedCompany: action.company }
  case sectorConstants.LINK_COMPANY_FAILURE:
    return { ...state,
      selectedCompany: null,
      error:action.error }
  case sectorConstants.LINK_CHART_REQUEST:
    return {
      ...state,
      chartNode: action.node,
      selectedCompanyNode:null,
      selectedCompany:null
    }
  case alertConstants.CLEAR:
    return {
      ...state,
      addSectorMessage: null,
      deletedData: {},
      isGetAllError: false,
      updateFilterMessage: null,
      isErrorOnUploadFilter: false,
      updateSectorMessage: null,
      chartDataMessage: null,
    }
  case sectorConstants.GET_SI_CHART_DATA_REQUEST:
    return {
      ...state,
      loading: true,
      chartDataMessage: null
    }
  case sectorConstants.GET_SI_CHART_DATA_SUCCESS:
    return {
      ...state,
      loading: false,
      chartDataMessage: 'success',
      industryChartData: action.sector
    }
  case sectorConstants.GET_SI_CHART_DATA_FAILURE:
    return {
      ...state,
      loading: false,
      chartDataMessage: 'error',
      industryChartData: null,
      error: action.error
    }
  case sectorConstants.GET_CHART_DATA_REQUEST:
    return {
      ...state,
      loading: true,
      chartDataMessage: null
    }
  case sectorConstants.GET_CHART_DATA_SUCCESS:
    return {
      ...state,
      loading: false,
      chartDataMessage: 'success',
      chartData: action.sector,
      chartNode: null,
      selectedCompanyNode:null,
      selectedCompany:null
    }
  case sectorConstants.GET_CHART_DATA_FAILURE:
    return {
      ...state,
      loading: false,
      chartDataMessage: 'error',
      chartData: null,
      error: action.error
    }
  case sectorConstants.ADD_REQUEST:
    return {
      ...state,
      loading: true,
      addSectorMessage: null
    }
  case sectorConstants.ADD_SUCCESS:
    return {
      ...state,
      addSectorMessage: action.sector.message,
      loading: false,
    }

  case sectorConstants.GETALL_SUCCESS:
    return {
      ...state,
      sectorList: action.sector.data,
      isLoading: false,
      addSectorMessage: null,
    }
  case sectorConstants.GETALL_FAILURE:
    return {
      ...state,
      error: action.error,
      sectorList: [],
      isLoading: false,
      count: 0
    }
  case sectorConstants.GETALL_REQUEST:
    return {
      ...state,
      error: null,
      isLoading: true,
    }

  case sectorConstants.GETBYID_SUCCESS:
    return {
      ...state,
      sectorEntry: action.sector,
      isLoading: false,
      addSectorMessage: null,
      updateSectorMessage: null
    }
  case sectorConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addSectorMessage: null,
      updateSectorMessage: null
    }
  case sectorConstants.GETBYID_REQUEST:
    return {
      ...state,
      sectorEntry: action.sector,
      updateSectorMessage: null,
      isLoading: true,
      addsectorMessage: null
    }
  case sectorConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addSectorMessage: null,
      sectorEntry: null,
      currentPage: action.sector.start
    }
  case sectorConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      sectorList: [],
      count: 0,
      isGetAllError: true,
      addSectorMessage: null
    }
  case sectorConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addSectorMessage: null,
      sectorList: action.sector.data,
      count: action.sector.count,
      sectorEntry: null
    }
  case sectorConstants.DELETE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addSectorMessage: null,
      deletedData: {},
      isGetAllError: false,

    }
  case sectorConstants.DELETE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      deletedData: action.response,
      addSectorMessage: null
    }
  case sectorConstants.DELETE_FAILURE:
    return {
      ...state,
      isLoading: false,
      addSectorMessage: null
    }
  case sectorConstants.UPDATE_FILTER_REQUEST:
    return {
      ...state,
      isLoading: true,
      updateFilterMessage: null,
      isErrorOnUploadFilter: false
    }
  case sectorConstants.UPDATE_FILTER_SUCCESS:
    return {
      ...state,
      isLoading: false,
      updateFilterMessage: action.response.message,
      isErrorOnUploadFilter: false
    }
  case sectorConstants.UPDATE_FILTER_FAILURE:
    return {
      ...state,
      isLoading: false,
      updateFilterMessage: null,
      isErrorOnUploadFilter: true
    }
  case sectorConstants.UPDATE_REQUEST:
    return {
      ...state,
      loading: true,
      updateSectorMessage: null
    }
  case sectorConstants.UPDATE_SUCCESS:
    return {
      ...state,
      updateSectorMessage: action.sector.message,
      isLoading: false,
      sectorEntry:null
    }
  case sectorConstants.UPDATE_FAILURE:
    return {
      ...state,
      updateSectorMessage: action.sector.message,
      isLoading: false,
      error:action.error
    }
  default:
    return state
  }
}
